import React, { useEffect } from "react";
import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  Typography,
  message,
} from "antd";
import LoginSignupScreen from "./loginSignupScreen";

import { useDispatch, useSelector } from "react-redux";
import { NavLink as useNavigate } from "react-router-dom";

import { sharedLoginAction } from "../store/action/shared/authAction";
import CustomLoaderIcon from "../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";

const { Title } = Typography;
function OtpScreen() {
  const router = useNavigate();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { loading, error, sharedUserInfo } = sharedLogin;

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    try {
      await dispatch(sharedLoginAction(values.email, values.password));
      form.resetFields();
    } catch (error) {
      message.error("Please try again later");
    }
  };

  useEffect(() => {
    if (sharedUserInfo && sharedUserInfo?.payload) {
      if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "user"
      ) {
        if (
          sharedUserInfo?.empCompanies.length === 0 ||
          sharedUserInfo?.empCompanies.length > 1
        ) {
          router("/user/company", { replace: true });
        } else {
          router(
            `/user/dashboard/${sharedUserInfo?.empCompanies[0]?.companyId?._id}`
          );
        }
      }
    } else {
      if (
        sharedUserInfo &&
        sharedUserInfo?.email &&
        sharedUserInfo?.type === "admin"
      ) {
        if (sharedUserInfo?.company && sharedUserInfo?.planSub) {
          router("/admin/Dashboard", { replace: true });
        } else {
          if (sharedUserInfo?.company) {
            router("/admin/subscription");
          } else {
            router("/admin/company");
          }
        }
      }
    }
  }, [sharedUserInfo]);
  return (
    <Row>
      <LoginSignupScreen />

      <Col span={12} className="log-right-col">
        <div className="log-right-content-col-signup">
          <Title>Enter your OTP</Title>
          <p className="subtitle-Body-Large-Subtle subtitle-Body-Large-padding">
            Streamline your Time and Productivity
          </p>
          <Divider className="form-divider" />
          <Form
            form={form}
            name="normal_login"
            className="login-form"
            layout="vertical"
            autoComplete="on"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
          >
            <Form.Item
              name="otp"
              label="Enter your OTP"
              rules={[
                {
                  required: true,
                  message: "Please input your New Password",
                },
              ]}
            >
              <Input max={4} type="password" placeholder="_ _ _ _" />
            </Form.Item>

            {error && <p style={{ color: "red" }}>{error}</p>}
            <Form.Item>
              <Button
                type="primary"
                htmlType={loading ? "button" : "submit"}
                loading={loading}
              >
                Enter OTP
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  );
}

export default OtpScreen;
